module.exports = __webpack_public_path__ + "static/img/3.865b84b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R14/3.jpg
// module id = 1vZ0
// module chunks = 1